// A soft two-note chime for the end of a sprint, made on the spot so the app
// ships no sound files. Quiet by design: a sine tone with a slow fade.

let context: AudioContext | null = null

function audio(): AudioContext | null {
  if (typeof window === 'undefined' || typeof AudioContext === 'undefined') return null
  context ??= new AudioContext()
  return context
}

function tone(ctx: AudioContext, frequency: number, start: number, volume: number) {
  const osc = ctx.createOscillator()
  const gain = ctx.createGain()
  osc.type = 'sine'
  osc.frequency.value = frequency
  gain.gain.setValueAtTime(0, start)
  gain.gain.linearRampToValueAtTime(volume, start + 0.02)
  gain.gain.exponentialRampToValueAtTime(0.0001, start + 1.4)
  osc.connect(gain).connect(ctx.destination)
  osc.start(start)
  osc.stop(start + 1.5)
}

/** 'end' rings two notes; 'warn' one, softer. */
export function playChime(kind: 'end' | 'warn' = 'end') {
  const ctx = audio()
  if (!ctx) return
  void ctx.resume()
  const now = ctx.currentTime
  if (kind === 'warn') {
    tone(ctx, 659.25, now, 0.08)
    return
  }
  tone(ctx, 783.99, now, 0.12)
  tone(ctx, 1046.5, now + 0.18, 0.1)
}
